/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc
 */
import * as References from './ServiceCatalogServiceRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServices
 */
export const GET_SERVICES_QUERY_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServices';
export const GET_SERVICES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERVICES_QUERY_FIELD_NAME,
  args: ['categoryId', 'apiName', 'active', 'language', 'includeAllLanguages'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getServicesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServiceById
 */
export const GET_SERVICE_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServiceById';
export const GET_SERVICE_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERVICE_BY_ID_QUERY_FIELD_NAME,
  args: ['id', 'language', 'includeAllLanguages'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getServiceByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServicesPaged
 */
export const GET_SERVICES_PAGED_QUERY_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServicesPaged';
export const GET_SERVICES_PAGED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERVICES_PAGED_QUERY_FIELD_NAME,
  args: ['categoryId', 'apiName', 'active', 'language', 'includeAllLanguages', 'after', 'before', 'limit'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getServicesPagedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#getServicesByIds
 */
export const GET_SERVICES_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_getServicesByIds';
export const GET_SERVICES_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SERVICES_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids', 'language', 'includeAllLanguages'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getServicesByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#createService
 */
export const CREATE_SERVICE_MUTATION_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_createService';
export const CREATE_SERVICE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_SERVICE_MUTATION_FIELD_NAME,
  args: ['active', 'name', 'description', 'translationKey', 'categoryId', 'brief', 'apiName', 'credentials'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.createServiceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc#updateService
 */
export const UPDATE_SERVICE_MUTATION_FIELD_NAME = 'com_hubspot_service_catalog_rpc_ServiceCatalogServiceRpc_updateService';
export const UPDATE_SERVICE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SERVICE_MUTATION_FIELD_NAME,
  args: ['id', 'active', 'brief', 'description', 'apiName', 'credentials'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.updateServiceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});